export default __webpack_public_path__ + "static/media/ic_search_big.6b72bce0.svg";